import jwt from "jsonwebtoken";
import { checkResponse } from "../utils/checkResponse";
import {
  APIKey,
  Authorization,
  Channel,
  DomainAPI,
  SecretApiKey,
  SecretApiKeyExpires,
} from "../utils/setting";

const serviceBranch = {
  state: {
    infoServiceBranch: {},
    serviceBranch: [],
    // newServiceBranch: []
    listBranch: [],
    total: 0,
    count: 0,
  },
  reducers: {
    setState(state, payload) {
      state = { ...state, ...payload };
      return { ...state };
    },
    setInfoBranch(state, payload) {
      state.infoServiceBranch = payload;
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    async createBranchForRole(payload, rootState) {
      let url =
        DomainAPI + Channel + "/api/secure/serviceBranches/createBranchForRole";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "post",
        headers: myHeaders,
        body: JSON.stringify({
          formData: payload.data,
          serviceCode: rootState.service.adminService
            ? rootState.service.adminService.no
            : null || null,
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    async getBranchForOwner(payload = {}, rootState) {
      const _this = this;
      let url =
        DomainAPI + Channel + "/api/secure/serviceBranches/getBranchForOwner";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1)
            _this.setState({
              serviceBranch: result.data.list,
              total: result.data.total,
              count: result.data.count,
            });
          return result;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    async updateBranchForOwner(payload, rootState) {
      let url =
        DomainAPI +
        Channel +
        "/api/secure/serviceBranches/updateBranchForOwner";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "post",
        headers: myHeaders,
        body: JSON.stringify({
          formData: payload.data,
          serviceCode: rootState.service.adminService
            ? rootState.service.adminService.no
            : null || null,
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    async updateImageGallery(payload, rootState) {
      let url =
        DomainAPI + Channel + "/api/secure/serviceBranches/updateImageGallery";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "post",
        headers: myHeaders,
        body: JSON.stringify({
          imageGallery: payload.imageGallery,
          branchCode: payload.branchCode,
          serviceCode: rootState.service.adminService
            ? rootState.service.adminService.no
            : null || null,
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    async deleteBranchForOwner(payload, rootState) {
      let url =
        DomainAPI +
        Channel +
        "/api/secure/serviceBranches/deleteBranchForOwner";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "post",
        headers: myHeaders,
        body: JSON.stringify({
          listBranchDelete: payload.listBranchDelete,
          serviceCode: rootState.service.adminService
            ? rootState.service.adminService.no
            : null || null,
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    async getInfoBranch(payload, rootState) {
      if (payload === " ") this.setState({ infoServiceBranch: {} });
      else {
        const _this = this;
        let data = {
          branchCode: payload,
        };
        let url =
          DomainAPI + Channel + "/api/secure/serviceBranches/getInfoBranch";
        let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
          expiresIn: SecretApiKeyExpires,
        });
        let myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append(APIKey, key);
        myHeaders.append(Authorization, rootState.user.token);

        return fetch(url, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((result) => {
            checkResponse(result, dispatch);
            if (result.code === 1)
              _this.setState({ infoServiceBranch: result.data[0] });
            return result.code === 1 ? true : false;
          })
          .catch((error) => {
            return false;
          });
      }
    },
    async getListBranch(payload, rootState) {
      const _this = this;
      let myHeaders = new Headers();
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(
        DomainAPI + Channel + "/api/secure/serviceBranches/getListBranch",
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(payload),
        }
      )
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) _this.setState({ listBranch: result.data });
          return result.code === 1 ? true : false;
        })
        .catch((error) => {
          return false;
        });
    },
  }),
};

export default serviceBranch;
